import api from '../api';

/**
 * Get dashboard statistics
 * @returns Dashboard statistics data
 */
export const getDashboardStats = async () => {
  const response = await api.get('/dashboard/stats');
  return response.data;
};

/**
 * Get recent adherents
 * @param limit Number of adherents to return (default 5)
 * @returns Recent adherents data
 */
export const getRecentAdherents = async (limit = 5) => {
  const response = await api.get(`/dashboard/recent-adherents?limit=${limit}`);
  return response.data;
};

/**
 * Get distribution data
 * @returns Distribution data for NAF codes, departments, etc.
 */
export const getDistributions = async () => {
  const response = await api.get('/dashboard/distributions');
  return response.data;
};

/**
 * Get all adherents with their locations for the map
 * @returns Adherents with location data for mapping
 */
export const getAdherentsForMap = async () => {
  const response = await api.get('/dashboard/adherent-map');
  return response.data;
}; 